import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Backdrop, Button, CircularProgress, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { ConfirmDialog } from '@shared/ui';
import {
  $checkAndSavePending,
  $isBackConfirmDialogOpened,
  $relatedAvailable,
  setAddRelation,
  setIsBackConfirmDialogOpened,
  startRelatedCheck,
} from '../../../../models/related-tickets';
import * as Styled from '../../styled';

export const Actions = () => {
  const { t } = useTranslation();
  const [relatedAvailable, checkAndSavePending, isBackConfirmDialogOpened] = useUnit([
    $relatedAvailable,
    $checkAndSavePending,
    $isBackConfirmDialogOpened,
  ]);

  const onClickClose = () => {
    if (!relatedAvailable.length) {
      setAddRelation(false);

      return;
    }

    setIsBackConfirmDialogOpened(true);
  };

  return (
    <>
      <Backdrop open={checkAndSavePending}>
        <CircularProgress />
      </Backdrop>

      <Styled.Header>
        <ConfirmDialog
          title={t('UndoingConnection')}
          content={<Typography variant="body1">{t('UnsavedDataWillBeLost')}</Typography>}
          isOpen={isBackConfirmDialogOpened}
          onClose={() => setIsBackConfirmDialogOpened(false)}
          onConfirm={() => {
            setIsBackConfirmDialogOpened(false);
            setAddRelation(false);
          }}
        />

        <Button
          startIcon={<CheckIcon />}
          variant="contained"
          disabled={!relatedAvailable.length}
          onClick={() => startRelatedCheck()}
        >
          {t('Save')}
        </Button>

        <Button startIcon={<CloseIcon />} variant="outlined" onClick={onClickClose}>
          {t('cancel')}
        </Button>
      </Styled.Header>
    </>
  );
};
